/**
 * The claims of a JWT, or `null` when the token is not one this can read.
 *
 * Decoded only, never verified: the server checks signatures, and the client
 * just needs `exp` and the session id to decide when to refresh or log out.
 */
export function readJwtClaims(token: string | null): Record<string, unknown> | null {
  try {
    const payload = token?.split(".")[1];
    if (!payload) return null;

    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = atob(base64 + "===".slice((base64.length + 3) % 4));
    const claims: unknown = JSON.parse(json);
    return claims && typeof claims === "object" ? (claims as Record<string, unknown>) : null;
  } catch {
    return null;
  }
}
